import type SignalCreateDTO from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalCreateDTO";
import type SignalUpdateDTO from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalUpdateDTO";
import type UISignal from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignal";

import type Signal from "../core/Signal";
import type SignalFilters from "../core/SignalFilters";
import type SignalSource from "../core/SignalSource";
import SignalType from "../core/SignalType";
import { SignalTimeframePeriod } from "../miscellaneous/SignalTimeframe";
import type NewsSignalFilters from "../news/NewsSignalFilters";
import type { SignalTemplateDeps } from "../templates/SignalTemplate";
import SignalTemplate from "../templates/SignalTemplate";

type NewsSignalTemplateDeps = Omit<SignalTemplateDeps<NewsSignalFilters>, "signalType">;

export default class NewsSignalTemplate extends SignalTemplate<NewsSignalFilters> {
    static defaultValues = {
        timeFrame: {
            period: SignalTimeframePeriod.Month,
            periodAmount: 1,
        },
    };

    constructor(deps: NewsSignalTemplateDeps) {
        super({ ...deps, signalType: SignalType.News });
    }

    isValid(): boolean {
        return typeof this.signalSubType !== "undefined";
    }

    matchesSignal(signal: Readonly<Signal<NewsSignalFilters>>): boolean {
        return signal.signalSubType === this.signalSubType;
    }

    getSignalCreateDTO<F extends SignalFilters>(
        filters: Readonly<F>,
        signalSource: SignalSource,
    ): Readonly<SignalCreateDTO<F>> {
        return {
            isDefault: false,
            signalType: this.signalType,
            signalSource: signalSource,
            signalSubType: this.signalSubType,
            lifecycleStatus: this.lifecycleStatus,
            filters,
        };
    }

    getSignalUpdateDTO<F extends SignalFilters>(
        uiSignal: Readonly<UISignal<F>>,
        filters: Readonly<F>,
    ): Readonly<SignalUpdateDTO<F>> {
        const { id, isDefault } = uiSignal;
        return {
            id,
            isDefault,
            signalType: this.signalType,
            signalSubType: this.signalSubType,
            filters,
        };
    }
}
